import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/store-cards/index.js